export default __webpack_public_path__ + "img/whelp.64cc1668.svg";